export enum Locales {
  PORTUGUESE_BR = 'pt-BR',
  PORTUGUESE = 'pt',
  ENGLISH_US = 'en-US',
  ENGLISH = 'en',
  SPANISH = 'es',
}

const localeMap: { [key: string]: () => Promise<any> } = {
  [Locales.PORTUGUESE_BR]: () => import('../../lang/pt-BR'),
  [Locales.PORTUGUESE]: () => import('../../lang/pt-BR'),
  [Locales.ENGLISH_US]: () => import('../../lang/en-US'),
  [Locales.ENGLISH]: () => import('../../lang/en-US'),
  [Locales.SPANISH]: () => import('../../lang/es-ES'),
};

export const loadMessages = async (locale: string) => {
  const loadLocale = localeMap[locale] || localeMap[Locales.PORTUGUESE_BR];
  const messages = await loadLocale();
  return messages.default;
};
